import { render, staticRenderFns } from "./AboutGrinView.vue?vue&type=template&id=7d286add&scoped=true&"
import script from "./AboutGrinView.vue?vue&type=script&lang=js&"
export * from "./AboutGrinView.vue?vue&type=script&lang=js&"
import style0 from "./AboutGrinView.vue?vue&type=style&index=0&id=7d286add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d286add",
  null
  
)

export default component.exports